import template from './branch_performance.html';
import controller from './branch_performance.controller';
import './branch_performance.scss';

let branchManagementBranchPerformanceComponent = {
    restrict: "E",
    binding: {},
    template,
    controller
}

export default branchManagementBranchPerformanceComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/branch_performance/branch_performance.component.js